import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-242d7c55"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "print-info-container"
}
const _hoisted_2 = { class: "info-title header weight" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-title weight" }, "1. Basic Information", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-title weight" }, "2. Bill Information", -1))
const _hoisted_5 = { class: "info-title second weight" }
const _hoisted_6 = {
  key: 5,
  class: "info-title weight"
}
const _hoisted_7 = {
  key: 6,
  class: "info-title weight"
}
const _hoisted_8 = { class: "print-author" }
const _hoisted_9 = { style: {"margin-left":"20px"} }
const _hoisted_10 = {
  key: 0,
  style: {"margin-left":"20px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_we_info_row = _resolveComponent("we-info-row")!
  const _component_we_print = _resolveComponent("we-print")!

  return (_openBlock(), _createBlock(_component_we_print, {
    show: _ctx.showPrintPage,
    "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showPrintPage) = $event)),
    onPrintClicked: _ctx.payPrintClicked
  }, {
    default: _withCtx(() => [
      (!_ctx.isEmptyData(_ctx.info))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(`${_ctx.pay.is_purchase ? 'Purchase ' : ''}Payment application`), 1),
            _hoisted_3,
            _createVNode(_component_we_info_row, {
              label: "Applicant",
              value: _ctx.userMap[_ctx.pay.creator_id] && _ctx.userMap[_ctx.pay.creator_id].name
            }, null, 8, ["value"]),
            _createVNode(_component_we_info_row, {
              label: "我方主体",
              value: _ctx.pay.we_company_name
            }, null, 8, ["value"]),
            _createVNode(_component_we_info_row, {
              label: "Beneficiary Company",
              value: _ctx.pay.company_name
            }, null, 8, ["value"]),
            _createVNode(_component_we_info_row, {
              label: "Currency",
              value: _ctx.pay.currency.unit
            }, null, 8, ["value"]),
            (!_ctx.isDirect)
              ? (_openBlock(), _createBlock(_component_we_info_row, {
                  key: 0,
                  label: "Category",
                  value: _ctx.pay.rd_pay_category_name
                }, null, 8, ["value"]))
              : (_openBlock(), _createBlock(_component_we_info_row, {
                  key: 1,
                  label: "Category",
                  value: _ctx.pay.cat1_name + '-' + _ctx.pay.cat2_name
                }, null, 8, ["value"])),
            _createVNode(_component_we_info_row, {
              label: "分类",
              value: _ctx.pay.cat1_name
            }, null, 8, ["value"]),
            _createVNode(_component_we_info_row, {
              label: "Amount to Pay",
              value: _ctx.formatNumber(_ctx.pay.pay_money, '0,0.00')
            }, null, 8, ["value"]),
            _createVNode(_component_we_info_row, {
              label: "Bank Charge Type",
              value: _ctx.pay.rd_pay_fee_type_name
            }, null, 8, ["value"]),
            _createVNode(_component_we_info_row, {
              label: "Pay Method",
              value: _ctx.pay.pay_method_name
            }, null, 8, ["value"]),
            (_ctx.pay.bank_id)
              ? (_openBlock(), _createBlock(_component_we_info_row, {
                  key: 2,
                  label: "BEN's Bank Info.",
                  value: _ctx.bankInfo
                }, null, 8, ["value"]))
              : (!_ctx.isEmptyData(_ctx.pay.bank_info))
                ? (_openBlock(), _createBlock(_component_we_info_row, {
                    key: 3,
                    label: "BEN's Bank Info.",
                    value: _ctx.pay.bank_info
                  }, null, 8, ["value"]))
                : _createCommentVNode("", true),
            _createVNode(_component_we_info_row, {
              label: "Plan Pay Date",
              value: _ctx.pay.plan_pay_time
            }, null, 8, ["value"]),
            (_ctx.linkBill && _ctx.linkBill.length)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                  _hoisted_4,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.linkBill, (bill, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "bill-list"
                    }, [
                      _createElementVNode("div", _hoisted_5, _toDisplayString(`2-${index + 1} Linked Bill Infomation`), 1),
                      _createVNode(_component_we_info_row, {
                        label: "Name",
                        value: bill.name
                      }, null, 8, ["value"]),
                      _createVNode(_component_we_info_row, {
                        label: "BG",
                        value: bill.rd_team_group_name
                      }, null, 8, ["value"]),
                      _createVNode(_component_we_info_row, {
                        label: "Team",
                        value: bill.rd_team_name
                      }, null, 8, ["value"]),
                      _createVNode(_component_we_info_row, {
                        label: "Owner",
                        value: bill.rd_owner_name
                      }, null, 8, ["value"]),
                      _createVNode(_component_we_info_row, {
                        label: "Amount to Pay",
                        value: _ctx.formatNumber(bill.this_linked_money, '0,0.00')
                      }, null, 8, ["value"]),
                      _createVNode(_component_we_info_row, {
                        label: "Invoice No.",
                        value: bill.invoice_number
                      }, null, 8, ["value"])
                    ]))
                  }), 128))
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.linkBill && _ctx.linkBill.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, "3. Approval Information"))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, "2. Approval Information")),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pay.flow.state_list, (state, index) => {
              return (_openBlock(), _createBlock(_component_we_info_row, {
                label: `${state.show_time} ${state.state_desc}`,
                value: _ctx.pay.is_purchase ? '' : state.note,
                key: index
              }, null, 8, ["label", "value"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _createTextVNode(_toDisplayString(`Printed by：${_ctx.user.name}`) + " ", 1),
        _createElementVNode("span", _hoisted_9, _toDisplayString(`Print Time：${_ctx.getNow()}`), 1),
        (_ctx.pay.printed_count)
          ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(`Printed Times：${_ctx.pay.printed_count}`), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["show", "onPrintClicked"]))
}